import { render } from "./caminhoes.vue?vue&type=template&id=c8c9a140&scoped=true&ts=true"
import script from "./caminhoes.vue?vue&type=script&lang=ts"
export * from "./caminhoes.vue?vue&type=script&lang=ts"

import "./caminhoes.vue?vue&type=style&index=0&id=c8c9a140&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8c9a140"]])

export default __exports__